const KYC = (state = {}, action) => {
  switch (action.type) {
    case 'SET_MIN_KYC_DETAILS': {
      return {
        ...state,
        ...action.data,
      };
    }
    case 'ADDRESS_INFO': {
      return {
        ...state,
        addressInfo: action.data,
      };
    }
    case 'VIDEO_KYC_LINK': {
      return {
        ...state,
        kycVideoLink: action.link,
      };
    }
    case 'SET_DOC_TYPE': {
      return {
        ...state,
        kycDocType: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default KYC;
